const mediaItems = [
  {
    title: '庆余年3 · 幕后花絮特辑',
    desc: '独家整理第三季拍摄现场花絮与主创访谈精华，深入了解权谋大剧的创作故事。',
    duration: '15:32',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20Chinese%20historical%20drama%20filming%2C%20warm%20studio%20lighting%2C%20costume%20details%2C%20cinematic%20production%20atmosphere%2C%20golden%20amber%20tones%2C%20professional%20film%20set&width=800&height=500&seq=media-feature-01&orientation=landscape',
  },
  {
    title: '背着善宰跑 · 名场面盘点',
    desc: '回顾剧中那些让人心动的高甜名场面，每一帧都值得反复回味。',
    duration: '12:08',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20highlight%20moments%20compilation%2C%20warm%20sunset%20lighting%2C%20dreamy%20atmosphere%2C%20young%20couple%20tender%20moments%2C%20soft%20golden%20glow%2C%20emotional%20cinematic%20scenes&width=800&height=500&seq=media-feature-02&orientation=landscape',
  },
  {
    title: '繁花 · 视觉美学解读',
    desc: '深度解析王家卫独特的镜头语言与光影美学，看繁花如何用画面讲故事。',
    duration: '20:45',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20visual%20aesthetic%20analysis%20scene%2C%20warm%20neon%20lights%20and%20shadows%2C%20artistic%20composition%2C%20golden%20and%20amber%20color%20palette%2C%20film%20noir%20style%2C%20sophisticated%20mood&width=800&height=500&seq=media-feature-03&orientation=landscape',
  },
  {
    title: '墨雨云间 · 服化道特辑',
    desc: '走进墨雨云间精致的服化道世界，看古装悬疑剧如何还原历史质感。',
    duration: '18:20',
    img: 'https://readdy.ai/api/search-image?query=Exquisite%20ancient%20Chinese%20costume%20and%20prop%20details%2C%20warm%20museum%20lighting%2C%20historical%20textile%20textures%2C%20elegant%20traditional%20aesthetic%2C%20soft%20amber%20tones%2C%20artisanal%20craftsmanship&width=800&height=500&seq=media-feature-04&orientation=landscape',
  },
  {
    title: '泪之女王 · 收视纪录回顾',
    desc: '盘点泪之女王创下的收视纪录与话题热度，金秀贤金智媛的演技名场面合集。',
    duration: '14:55',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20drama%20emotional%20scene%20with%20warm%20interior%20lighting%2C%20luxury%20setting%2C%20sophisticated%20atmosphere%2C%20golden%20and%20cream%20tones%2C%20tender%20and%20dramatic%20mood%2C%20cinematic%20composition&width=800&height=500&seq=media-feature-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block text-xs font-medium text-secondary-600 bg-secondary-100 px-3 py-1 rounded-full mb-3">
              特别企划
            </span>
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              精彩花絮
            </h2>
            <p className="text-sm text-foreground-500 mt-2">热门剧集的幕后故事与深度解读</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {mediaItems.map((item, i) => (
              <article
                key={i}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
              >
                <div className="relative aspect-video overflow-hidden bg-background-200">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background-50/90 backdrop-blur-sm flex items-center justify-center">
                      <i className="ri-play-fill text-primary-600 text-xl ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute bottom-3 right-3 px-2 py-0.5 bg-background-950/70 backdrop-blur-sm rounded text-xs text-background-50 font-mono">
                    {item.duration}
                  </span>
                </div>
                <div className="p-4">
                  <h3 className="text-sm font-bold text-foreground-900 mb-1.5 font-heading group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{item.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}